import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { FilterQuery } from "../../types/query";
import { User } from "../../types/user";
import { api } from "./index.api";
import toastError from "../../components/notif";
import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
function usersApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      return toastError("UnknownError please try again later");
  }
}

const userEntityAdapter = createEntityAdapter<User, string>({
  selectId: (user: User) => user._id,
});

export type GetUsersType = {
  users: EntityState<User, string>;
  length: number;
  from: number;
};

const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<GetUsersType, FilterQuery<User>>({
      query: (input) => ({
        url: "/users",
        params: input,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          usersApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      transformResponse(
        baseQueryReturnValue: { users: any; length: number; from: number },
        meta,
        arg
      ) {
        return {
          users: userEntityAdapter.addMany(
            userEntityAdapter.getInitialState(),
            baseQueryReturnValue.users as any
          ),
          length: baseQueryReturnValue.length,
          from: baseQueryReturnValue.from,
        };
      },
      providesTags: ["users"],
    }),
    addUser: builder.mutation<void, FormData>({
      query: (input) => ({
        url: "/admin/users",
        method: "POST",
        body: input,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          usersApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["users"];
      },
    }),
    updateUser: builder.mutation<void, { data: FormData; userId: string }>({
      query: (input) => ({
        url: `/admin/users/${input.userId}`,
        method: "PUT",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          usersApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["users"];
      },
    }),
    deleteUser: builder.mutation<void, string>({
      query: (input) => ({
        url: `/admin/users/${input}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          usersApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return ["users"];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetUsersQuery,
  useAddUserMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
} = usersApi;
